import { flow, lowerCase, snakeCase, startCase, toUpper } from 'lodash';

import { LOCATION_CARD_KEY } from '../../../LocationCard/constants';
import { AnalyticsTypes } from '../../../../middleware/google-analytics';
import { PROFILE_GA_CATEGORY } from '../../../../Profile/constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../../EventTrackingConstants';

const constantCase = flow([snakeCase, toUpper]);

export const trackClickIBubbleClick = title => ({
    type: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_${constantCase(title)}`,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: `Click I Bubble ${startCase(title)}`,
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.I_BUBBLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: `click ${lowerCase(title)}`,
            },
        },
    },
});
